import React, { useEffect, useState } from 'react';
import { getDangerZone } from '../lib/api';

export default function DangerZone({ onSearchingChange }) {
    const [ranking, setRanking] = useState([]);

    const stats = {
        games: 128,
        wins: 72,
        winrate: '56.3%',
        kdr: 1.24,
        bestStreak: 7,
    };

    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        let isMounted = true;
        getDangerZone()
            .then(res => res.json())
            .then(data => {
                if (isMounted && Array.isArray(data)) {
                    setRanking(data);
                }
            })
            .catch(err => console.error("Failed to fetch dangerzone ranking:", err));
        return () => { isMounted = false; };
    }, []);

    useEffect(() => {
        // Inform parent when searching state changes
        if (typeof onSearchingChange === 'function') {
            onSearchingChange(!!isSearching);
        }
    }, [isSearching, onSearchingChange]);

    useEffect(() => {
        // Cleanup when unmounting: ensure we stop searching
        return () => {
            if (typeof onSearchingChange === 'function') onSearchingChange(false);
        };
    }, [onSearchingChange]);

    const startSearch = () => {
        setIsSearching(true);
        // TODO: hook into real matchmaking start
    };
    const stopSearch = () => {
        setIsSearching(false);
        // TODO: hook into real matchmaking stop
    };

    const getRankImage = (rating) => {
        if (rating < 1000) return '/dz_ranks/bronze.webp';
        if (rating < 2000) return '/dz_ranks/silver.webp';
        if (rating < 3000) return '/dz_ranks/gold.webp';
        if (rating < 4000) return '/dz_ranks/daimond.webp';
        return '/dz_ranks/master.webp';
    };

    return (
        <div className="container">
            <div className="danger-layout">
                {/* Left column: Ranking table styled like servers table */}
                <section className="danger-left" aria-label="Danger Zone Rankings">
                    <div className="grid-wrapper" style={{'--grid-cols': '64px 48px 1fr 80px 120px '}}>
                        <div className="grid-head">
                            <div className="gh-col">#</div>
                            <div className="gh-col"></div>
                            <div className="gh-col name">Player</div>
                            <div className="gh-col">Rank</div>
                            <div className="gh-col right">Rating</div>
                        </div>
                        <div className="servers-grid">
                            {ranking.map((r, idx) => (
                                <div key={r.steam_id || idx} className="server-row">
                                    <div className="cell">{idx + 1}</div>
                                    <div className="cell">
                                        {r.avatar && <img src={r.avatar} alt="" style={{ width: '32px', height: '32px', borderRadius: '4px' }} />}
                                    </div>
                                    <div className="cell name">{r.name}</div>
                                    <div className="cell">
                                        <img src={getRankImage(r.points)} alt="" style={{ height: '32px'}}/>
                                    </div>
                                    <div className="cell right">{r.points}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Right column: Search button + stats */}
                <aside className="danger-right" aria-label="Danger Zone Actions and Stats">
                    {!isSearching ? (
                        <button className="dz-search-btn" type="button" onClick={startSearch}>Search Game</button>
                    ) : (
                        <button className="dz-search-btn" type="button" onClick={stopSearch} style={{background: '#fca5a5', color: '#230a0a'}}>Stop Searching</button>
                    )}

                    <div className="dz-stats">
                        <h3>Your Stats</h3>
                        <div className="dz-stats-grid">
                            <div className="dz-stat"><span className="label">Games</span><span className="value">{stats.games}</span></div>
                            <div className="dz-stat"><span className="label">Wins</span><span className="value">{stats.wins}</span></div>
                            <div className="dz-stat"><span className="label">Winrate</span><span className="value">{stats.winrate}</span></div>
                            <div className="dz-stat"><span className="label">K/D</span><span className="value">{stats.kdr}</span></div>
                            <div className="dz-stat"><span className="label">Best Streak</span><span className="value">{stats.bestStreak}</span></div>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    );
}